import { LoggerConfig, LogLevel } from '../interfaces/logger.interface';

// Development configuration
export const developmentLoggerConfig: Partial<LoggerConfig> = {
  minLevel: LogLevel.DEBUG,
  enableStackTrace: true,
  enableSourceMapping: true,
  maxRetries: 3,
  bufferSize: 1,
  flushInterval: 0 // Immediate logging in development
};

// QA configuration
export const qaLoggerConfig: Partial<LoggerConfig> = {
  minLevel: LogLevel.INFO,
  enableStackTrace: true,
  enableSourceMapping: true,
  maxRetries: 5,
  bufferSize: 10,
  flushInterval: 5000 // 5 seconds
};

// Production configuration
export const productionLoggerConfig: Partial<LoggerConfig> = {
  minLevel: LogLevel.ERROR,
  enableStackTrace: false,
  enableSourceMapping: false,
  maxRetries: 3,
  bufferSize: 50,
  flushInterval: 10000 // 10 seconds
};